const BASE_URL = process.env.REACT_APP_BEX_SERVER_URL || '';

function getHeaders(configKey) {
    return {
        'Content-Type': 'application/json',
        'x-config-key': configKey,
    };
}

function configFetch(path, options = {}) {
    return fetch(`${BASE_URL}${path}`, {
        credentials: 'include',
        ...options,
        headers: {
            ...getHeaders(options.configKey || ''),
            ...(options.headers || {}),
        },
    });
}

async function handleResponse(res) {
    const json = await res.json();
    if (!res.ok) {
        const err = new Error(json.message || `Request failed: ${res.status}`);
        err.status = res.status;
        throw err;
    }
    return json.data;
}

export async function fetchResources(instanceId, configKey) {
    const res = await configFetch(`/api/broker/config/instances/${instanceId}/resources`, { configKey });
    return handleResponse(res);
}

export async function createChannel(instanceId, configKey, body) {
    const res = await configFetch(`/api/broker/config/instances/${instanceId}/channels`, {
        method: 'POST',
        configKey,
        body: JSON.stringify(body),
    });
    return handleResponse(res);
}

export async function updateChannel(instanceId, configKey, channelId, body) {
    const res = await configFetch(`/api/broker/config/instances/${instanceId}/channels/${channelId}`, {
        method: 'PUT',
        configKey,
        body: JSON.stringify(body),
    });
    return handleResponse(res);
}

export async function fetchInstructions(instanceId, configKey) {
    const res = await configFetch(`/api/broker/config/instances/${instanceId}/instructions`, { configKey });
    return handleResponse(res);
}

export async function updateInstruction(instanceId, configKey, body) {
    const res = await configFetch(`/api/broker/config/instances/${instanceId}/instructions`, {
        method: 'PUT',
        configKey,
        body: JSON.stringify(body),
    });
    return handleResponse(res);
}

export async function updateStep(instanceId, configKey, body) {
    const res = await configFetch(`/api/broker/config/instances/${instanceId}/steps`, {
        method: 'PUT',
        configKey,
        body: JSON.stringify(body),
    });
    return handleResponse(res);
}

export async function createApi(instanceId, configKey, body) {
    const res = await configFetch(`/api/broker/config/instances/${instanceId}/apis`, {
        method: 'POST',
        configKey,
        body: JSON.stringify(body),
    });
    return handleResponse(res);
}

export async function deleteApi(instanceId, configKey, apiId) {
    const res = await configFetch(`/api/broker/config/instances/${instanceId}/apis/${apiId}`, {
        method: 'DELETE',
        configKey,
    });
    return handleResponse(res);
}

export async function updateApi(instanceId, configKey, apiId, body) {
    const res = await configFetch(`/api/broker/config/instances/${instanceId}/apis/${apiId}`, {
        method: 'PUT',
        configKey,
        body: JSON.stringify(body),
    });
    return handleResponse(res);
}

export async function listCollectionFiles(instanceId, configKey, collectionId) {
    const res = await configFetch(`/api/broker/config/instances/${instanceId}/collections/${collectionId}/files`, { configKey });
    return handleResponse(res);
}

export async function getPresignedUrls(instanceId, configKey, collectionId, fileNames, prefix = '') {
    const res = await configFetch(`/api/broker/config/instances/${instanceId}/collections/${collectionId}/presigned-urls`, {
        method: 'POST',
        configKey,
        body: JSON.stringify({
            fileNames,
            prefix
        }),
    });
    return handleResponse(res);
}

export async function fetchWhatsappQr(instanceId, configKey, sessionId) {
    const res = await configFetch(`/api/broker/config/instances/${instanceId}/whatsapp/qr/${sessionId}`, { configKey });
    return handleResponse(res);
}

export async function fetchWhatsappStatus(instanceId, configKey, sessionId) {
    const res = await configFetch(`/api/broker/config/instances/${instanceId}/whatsapp/status/${sessionId}`, { configKey });
    return handleResponse(res);
}

export async function fetchWhatsappPairingCode(instanceId, configKey, sessionId, phoneNumber) {
    const res = await configFetch(`/api/broker/config/instances/${instanceId}/whatsapp/pairing-code/${sessionId}`, {
        method: 'POST',
        configKey,
        body: JSON.stringify({
            phoneNumber
        }),
    });
    return handleResponse(res);
}

export async function disconnectWhatsapp(instanceId, configKey, sessionId, channelId) {
    const res = await configFetch(`/api/broker/config/instances/${instanceId}/whatsapp/disconnect/${sessionId}`, {
        method: 'DELETE',
        configKey,
        body: JSON.stringify({
            channelId
        }),
    });
    return handleResponse(res);
}

export async function chatWithAssistant(instanceId, configKey, body) {
    const res = await configFetch(`/api/broker/config/instances/${instanceId}/chat`, {
        method: 'POST',
        configKey,
        body: JSON.stringify(body),
    });
    return handleResponse(res);
}

export async function processCollection(instanceId, configKey, collectionId) {
    const res = await configFetch(`/api/broker/config/instances/${instanceId}/collections/${collectionId}/process`, {
        method: 'POST',
        configKey,
    });
    return handleResponse(res);
}

export async function deleteCollectionFiles(instanceId, configKey, collectionId, fileKeys) {
    const res = await configFetch(`/api/broker/config/instances/${instanceId}/collections/${collectionId}/files`, {
        method: 'DELETE',
        configKey,
        body: JSON.stringify({
            fileKeys
        }),
    });
    return handleResponse(res);
}
